export const CREATE_AD_HOC_ERROR_TOAST_ID = 'global-bill-modal-create-adhoc-error-toast';
export const createAdHocForContact = async (param)=>{
    let { api, recipientContactId, handleOpenAdHocBill, dismissModal, overlayContext, errorMessage, setIsCreatingAdHoc } = param;
    setIsCreatingAdHoc(true);
    try {
        const { relationshipId } = await api.relationship.createAdHoc(recipientContactId);
        handleOpenAdHocBill(relationshipId);
        dismissModal();
    } catch (unused) {
        overlayContext.showErrorToast(errorMessage, CREATE_AD_HOC_ERROR_TOAST_ID);
    } finally{
        setIsCreatingAdHoc(false);
    }
};
